module.exports = __webpack_public_path__ + "img/reset_scale_step_1.ed3521a4.png";